module.exports = __webpack_public_path__ + "static/media/tn-mpants-ankle-short.c652043e.svg";